import { Component, OnInit, HostListener, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'global-drop-down-list',
  templateUrl: './global-drop-down-list.component.html',
  styleUrls: ['./global-drop-down-list.component.scss']
})
export class GlobalDropDownListComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {

    this.tempContent = this.ddlContent;
    this.searchTerm = this.selectedValue;
  }
  searchTerm: string;
  showDdl: boolean;
  tempContent: any = [];
  arrowkeyLocation: any;
  @Input("ddlContent") ddlContent = [];
  @Input() key;
  @Input("focus") focus;
  @Input() placeHolder;
  @Input("selectedValue") selectedValue;
  @Output() selectedVal = new EventEmitter();
  @Input() isDisabled: boolean = false;
  @ViewChild('isFocus') isFocus: ElementRef;

  constructor(private utilities: UtilitiesService) {
    this.arrowkeyLocation = 0;
  }

  @HostListener('window:keyup.enter')
  changeByEnterkey() {
      var _currency = this.tempContent as any[];
      var currency = _currency[this.arrowkeyLocation];
      this.change(currency);
      this.showDdl = false;
  }

  search(e) {
    this.searchTerm = e.target.value.toLowerCase();
    this.showDdl = true;
    if (this.searchTerm != "" && this.searchTerm != undefined && this.searchTerm != null && e.which != 8) {
      this.tempContent = this.ddlContent.filter((x, i) => {
        try {
          return x[this.key].toLowerCase().startsWith(e.target.value.toLowerCase());
        }
        catch (e) {
          return e.Message;
        }
      });
      if (this.tempContent.length == 0) {
        this.selectedVal.emit(null);
      }
    }
    else {
      this.tempContent = [];
      this.showDdl = false;
    }
  }

  change(item) {
    if (!this.isDisabled) {
      this.searchTerm = item.key;
      this.selectedVal.emit(item)
      this.showDdl = false;
    }
  }

  @HostListener('window:keydown', ['$event'])
  onarrowDown(event) {
      if (event.key == 'ArrowDown') {
        if (this.arrowkeyLocation < this.tempContent.length - 1)
          return this.arrowkeyLocation++;
      }
      else {
        if (event.key == 'ArrowUp') {
          if (this.arrowkeyLocation > 0)
            return this.arrowkeyLocation--;
        }
      }
  }


  ngOnInit() {
    this.tempContent = this.ddlContent;
  }

}
